module.exports = __webpack_public_path__ + "static/timewise-291ec0a4cb8189c20542735698185b00.png";